import React from "react";

import { RadioButton } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  fieldsetCss,
  formHeaderCss,
  legendCss,
  listCss,
  radioButtonCss,
  unorderedListCss,
} from "./QuestionFlagForm.style";

const propTypes = {
  handleChange: PropTypes.func,
  options: PropTypes.array,
  selectedFlag: PropTypes.string,
};

const QuestionFlagForm = ({ handleChange, options, selectedFlag }) => {
  const renderFlagOptions = () => {
    return (
      <ul css={unorderedListCss}>
        {options?.map((option, index) => {
          return (
            <li key={`flag-option-${index}`} css={listCss}>
              <RadioButton
                __cssFor={{ root: radioButtonCss }}
                isSelected={selectedFlag === option}
                label={option}
                name="questionFlagRadio"
                onChange={() => handleChange(option)}
                value={option}
                withContainer
              />
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <>
      <h3 css={formHeaderCss} id="questionFlagHeading">
        Report Question
      </h3>
      <form role="form" aria-labelledby="questionFlagHeading">
        <fieldset css={fieldsetCss}>
          <legend css={legendCss}>Select a reason:</legend>
          {renderFlagOptions()}
        </fieldset>
      </form>
    </>
  );
};

QuestionFlagForm.propTypes = propTypes;

export default QuestionFlagForm;
